import React, { useEffect } from 'react'
import { HitApi } from '../../../Api/ApiHit';
import { searchSalonChild } from '../../../constant/Constant';
import AddSalonChild from './AddSalonChild';
import { setApiJson } from '../../../redux/Actions/ApiAction';
import { useDispatch, useSelector } from 'react-redux';

function EditSalonChild() {

    const ApiReducer = useSelector((state) => state.ApiReducer);
    const url = window.location.pathname;
    const UrlId = url.split('/')[2];
    const dispatch = useDispatch()

    useEffect(() => {
        if (UrlId) {
            getData()
        }
    }, [])

    const getData = () => {
        var json = {
            page: 1,
            limit: 1,
            search: {
                _id: UrlId
            }
        }
        HitApi(json, searchSalonChild).then((res) => {
            if (res?.statusCode === 200) {
                const data = res?.data?.docs?.[0];
                if (data) {
                    // Convert staffIds from objects to IDs
                    if (data.staffIds && data.staffIds.length > 0) {
                        data.staffIds = data.staffIds.map(staff =>
                            typeof staff === 'object' ? staff._id : staff
                        );
                    }
                    // Convert parentId from object to ID
                    if (data.parentId && typeof data.parentId === 'object') {
                        data.parentId = data.parentId._id;
                    }
                    // Convert unitIds from object to ID
                    if (data.unitIds && typeof data.unitIds === 'object') {
                        data.unitIds = data.unitIds._id;
                    }
                    dispatch(setApiJson(data));
                }
            }
        })
    }

    return (
        <div>
            <AddSalonChild editMode={true} />
        </div>
    )
}

export default EditSalonChild
